module.exports = __webpack_public_path__ + "static/46-45488168e4d19e864678418dbf03e521.png";